import { useContext, useEffect, useRef, useState } from "react";
import "./style.css";
import GlobalSearchResult from "../GlobalSearchResult";
import FilterHeader from "../Filter/FilterHeader";
import { HOMEIMAGES } from "../../constants/IMAGES";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CHECKOUTPAGE, EVENTSPAGE, HOMEPAGE, MYBOOKINGS, PRE_CHECKOUTPAGE } from "../../constants/RoutingPath";
import {
  AboutIcon,
  AboutMobIcon,
  AdminIcon,
  AdminMobileIcon,
  BackMobIcon,
  BellIcon,
  BellMobileIcon,
  BookingIcon,
  CallMobileIcon,
  CartIcon,
  ContactIcon,
  ContactMobIcon,
  CrossMobIcon,
  HamburgerIcon,
  HeaderCallIcon,
  HotelIcon,
  HotelMobIcon,
  LogOutIcon,
} from "../GlobalIcons";
import OutsideClick from "../OutsideClick";
import HeaderPopups from "./HeaderPopups";
import CustomModal from "../CustomModal";
import CartPopUp from "../CartPopUp";
import { filterDataContext } from "../../App";
import { useCookies } from "react-cookie";
import { callAMobileNumber } from "../../utils/func";

const HeaderNew = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [PopupShow, SetPopupShow] = useState(false);
  const [Show, SetShow] = useState("");
  const [showcart, setShowCart] = useState(false)
  const { cartQuantity, fetchCartList, checkoutReserVationId } = useContext(filterDataContext)
  const closeRef = useRef();
  const closeHeaderRef = useRef();
  const [cookies, setCookie, removeCookie] = useCookies([]);
  const navigate = useNavigate()



  const handleNavigateToBookings = () => {
    navigate(MYBOOKINGS)
  }

  const openMenu = () => {
    SetPopupShow(true);
  };

  const closeMenu = () => {
    SetPopupShow(false);
  };
  const togglePopup = (popupType) => {
    if (Show === popupType) {
      SetShow("");
    } else {
      SetShow(popupType);
    }
  };
  const ClosetogglePop = () => {
    SetShow("");
  };

  const closePopUp = (func) => {
    func();
  };

  useEffect(() => {
    if (location.pathname !== CHECKOUTPAGE && location.pathname !== PRE_CHECKOUTPAGE) {
      fetchCartList()
    }
  }, [checkoutReserVationId])


  const handleLogOut = () => {
    removeCookie(process.env.REACT_APP_API_TOKEN)
    const url = process.env.REACT_APP_TRP_HOTELS_URL;
    window.open(url, '_blank');
    window.close()
  }

  const redirectToHotelPage = (pageName) => {
    const url = process.env.REACT_APP_TRP_HOTELS_URL;
    window.open(`${url}/${pageName}`, "_blank")
  }


  return (
    <>
      {showcart && <CartPopUp closeFunc={closePopUp} closeFuncState={setShowCart} fetchCartList={fetchCartList} />}
      <div className="header" >
        <marquee className="guidelines">
          Important changes : Revision of TCS will be from 1st October 2023
          until then TCS is applicable as per govt. guidelines.
        </marquee>
        <div className="main_header_section">
          <div className="account_logout">
            <div className="header_container"  >
              <div className="header_menus_icon"  >
                <div className="logout_trp" onClick={handleLogOut} >
                  <span>
                    <LogOutIcon />
                  </span>
                  Back To TRP World
                </div>
                <ul

                  ref={window.innerWidth > 768 ? closeHeaderRef : null}
                >
                  <li className="header_popup_parents">
                    <div
                      className="header_admin"
                      onClick={() => togglePopup("admin")}
                    >
                      <span>
                        <AdminIcon />
                      </span>{" "}
                      Account
                    </div>

                    {Show === "admin" ? (
                      <div className="popup_header_box">
                        {window.innerWidth < 768 ? (
                          <CustomModal
                            id={"Landing_page_pop"}
                            closeFunc={closePopUp}
                            closeFuncState={SetShow}
                            children={<HeaderPopups parent="account" />}
                          />
                        ) : (
                          <>{<HeaderPopups parent="account" />}</>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </li>

                  <li className="header_popup_parents" onClick={handleNavigateToBookings} >
                    <div
                      className="header_admin"

                    >
                      <span>
                        <BookingIcon />
                      </span>{" "}
                      Bookings
                    </div>
                  </li>

                  {togglePopup.length > 0 && (
                    <OutsideClick
                      closeRef={closeHeaderRef}
                      func={ClosetogglePop}
                      state={PopupShow}
                    />
                  )}
                  <li className="header_popup_parents">
                    <span
                      className="bellicon"
                      onClick={() => togglePopup("notification")}
                    >
                      <BellIcon />
                    </span>
                    {Show === "notification" ? (
                      <div className="popup_header_box">
                        {window.innerWidth < 768 ? (
                          <CustomModal
                            id={"Landing_page_pop"}
                            closeFunc={closePopUp}
                            closeFuncState={SetShow}
                            children={<HeaderPopups parent="notification" />}
                          />
                        ) : (
                          <>{<HeaderPopups parent="notification" />}</>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </li>



                  {
                    location.pathname !== CHECKOUTPAGE &&
                    <li onClick={() => setShowCart(true)} >
                      <span className="carticon">
                        <CartIcon /> <span className="qartQuantity" >{cartQuantity}</span>
                      </span>
                    </li>
                  }

                  {/* <li>
                    <LogOutButton />

                  </li> */}

                </ul>
              </div>
            </div>
          </div>
          <div className="header_container new_container" style={{paddingBottom :( location.pathname === HOMEPAGE || location.pathname === EVENTSPAGE)? "60px" : "20px"}}>
            <div className="header_left">
              <Link
                to={HOMEPAGE}
                style={{
                  pointerEvents: location.pathname === HOMEPAGE ? "none" : "",
                }}
              >
                <img src={HOMEIMAGES.LOGO} alt="logo" />
              </Link>

            </div>
            <div className="header_right">
              <div className="menu_section">
                <ul>
                  {/* <li>
                    <span>
                      <HotelIcon />
                    </span>{" "}
                    HOTELS
                  </li> */}
                  <li onClick={() => redirectToHotelPage("about-us")}>
                    <span>
                      <AboutIcon />
                    </span>
                    About Us
                  </li>
                  <li onClick={() => redirectToHotelPage("contact-us")}>
                    <span className="bellicon">
                      <ContactIcon />
                    </span>
                    Contact Us
                  </li>
                </ul>
              </div>
              <GlobalSearchResult />
              <div className="call_section"
                onClick={(e) => {
                  e.preventDefault();
                  callAMobileNumber(+91 - 8800596344);
                }}
              >
                <HeaderCallIcon />
                <div className="call_text">
                  <p className="phone">+91 88005 96344</p>
                  <p className="availability">24/7 Available</p>
                </div>
              </div>

            </div>

            {location.pathname === "/" || location.pathname === "/events" ? (
              <div className="filters_section ">
                <FilterHeader />
              </div>
            ) : (
              ""
            )}

            <div className="desk_hide hamburger">
              <div className="mobile_side_menu_icons">
                <span onClick={() => togglePopup("admin")}>
                  <AdminMobileIcon />
                </span>
                <span onClick={() => togglePopup("notification")}>
                  <BellMobileIcon />
                </span>
                {
                  location.pathname !== CHECKOUTPAGE &&
                  <span className="carticon " onClick={() => setShowCart(true)}>
                    <CartIcon />
                    {cartQuantity > 0 && <span className="qartQuantity" >{cartQuantity}</span>}
                  </span>
                }
                <div onClick={openMenu}>
                  <HamburgerIcon />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="desk_hide mobile_global_search">
        <div className="mobile_container">
          <GlobalSearchResult ForMobile={"MobileGlobalSearch"} />
        </div>
      </div>

      <div
        ref={closeRef}
        className={`mobile_popup_headerr header desk_hide ${PopupShow ? "active" : ""
          }`}
      >
        {PopupShow === true && (
          <OutsideClick
            closeRef={closeRef}
            func={closeMenu}
            state={PopupShow}
          />
        )}
        <div className="header_mobile_pop_inner_sec">
          <div className="header_top">
            <div className="header_container">
              <Link>
                <img src={HOMEIMAGES.LOGO} alt="" />
              </Link>
              <div className="cross_and_call_pop">
                <Link 
                 onClick={(e) => {
                  e.preventDefault();
                  callAMobileNumber(+91 - 8800596344);
                }}
                >
                  <CallMobileIcon />
                </Link>
                <div onClick={closeMenu}>
                  <CrossMobIcon />
                </div>
              </div>
            </div>
          </div>
          <div className="bottom_pop_Section header_container">
            <ul>
              {/* <li>
                <HotelMobIcon />
                <span>HOTELS</span>
              </li> */}
              <li onClick={() => redirectToHotelPage("about-us")}>
                <AboutMobIcon />
                <span>About Us</span>
              </li>
              <li onClick={() => redirectToHotelPage("contact-us")}>
                <ContactMobIcon />
                <span>Contact Us</span>
              </li>
            </ul>
            <button onClick={handleLogOut}>
              <BackMobIcon />
              Back To TRP
            </button>
          </div>
        </div>
        {/* <div
            className="cross_icon_mobile_pop"
            onClick={() => SetPopupShow(false)}
          >
          </div> */}
      </div>
    </>
  );
};

export default HeaderNew;
